import { JSX, useEffect, useRef } from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import CloseIcon from "@mui/icons-material/Close";

export type InfoDrawerProps = {
	title: string;
	message: string;

	onClose: () => void;
};

const DRAWER_WIDTH = 350;

export default function InfoDrawer(
	props: Readonly<InfoDrawerProps>
): JSX.Element {
	return (
		<Drawer
			sx={{
				width: DRAWER_WIDTH,
				flexShrink: 0,
				[`& .MuiDrawer-paper`]: {
					width: DRAWER_WIDTH,
					boxSizing: "border-box"
				}
			}}
			anchor="right"
			open
			hideBackdrop={true}
			onClose={props.onClose}>
			<Toolbar />
			<Box sx={{ padding: 2 }}>
				<Grid
					container
					justifyContent="space-between"
					alignItems="center">
					<Grid item>
						<Typography variant="h6">{props.title}</Typography>
					</Grid>
					<Grid item>
						<IconButton onClick={props.onClose} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Grid>
				</Grid>
				<Typography
					component="div"
					aria-label="message"
					variant="body2"
					dangerouslySetInnerHTML={{
						__html: props.message
					}}
				/>
			</Box>
		</Drawer>
	);
}
